import {
	isBlank
}
from 'voUtils/tools.js';

export default {
	data() {
			return {
				name: undefined,
			};
		},
		mounted() {
			// Warte darauf, dass die DOM-Elemente sicher existieren
			this.$nextTick(() => {

				const isMobile = window.innerWidth < 768;
				const hangtagId = isMobile ? "hangtag-mobile" : "hangtag-desktop";

				const hangtag = document.getElementById(hangtagId);

				if (!hangtag) {
					return;
				}

				function setCookie(name, value, days) {
					let date = new Date();
					date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
					document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
				}

				// Funktion zum Abrufen eines Cookies
				function getCookie(name) {
					let cookies = document.cookie.split("; ");
					for (let cookie of cookies) {
						let [key, value] = cookie.split("=");
						if (key === name) {
							return value;
						}
					}
					return null;
				}

				if (!getCookie("hangtag")) {
					hangtag.classList.add("visible");
					setCookie("hangtag", "true", 1); // Cookie setzen (1 Tag Gültigkeit)
					setTimeout(() => {
						hangtag.classList.remove("visible");
					}, 10000);
				}

			});
		},
};